module.exports = __webpack_public_path__ + "media/images/ohap_help-5e67fdd053cf4c2c93557ce970c2139b.png";